<template>
  <section class="experience" id="experience">
    <div class="row">
      <div class="col-xl-12">
        <ul class="timeline-list">
          <li v-for="(item, index) in items" :key="index" :class="{ 'even': index % 2 === 1 }">
            <div class="timeline_content">
              <h2>{{ item.date }}</h2>
              <h3>{{ item.title }}</h3>
              <p v-html="item.text" style="font-size: 0.9rem;"></p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TimelineChart',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  }
};
</script>

<style scoped>
ul.timeline-list {
  position: relative;
  margin: 0;
  padding: 0;
  display: grid;
  row-gap: 40px;
}

ul.timeline-list::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #00f0ff;
}

ul.timeline-list li {
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr;
  position: relative;
  align-items: center;
}

ul.timeline-list li::before {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 20px;
  background-color: #00f0ff;
  border-radius: 50%;
}

.timeline_content {
  border: 2px solid #00f0ff;
  width: 80%;
  color: #ffffff;
  background-color: #323336;
  border-radius: 30px;
  padding: 1rem;
}

.timeline_content > * {
  margin: 0;
}

ul.timeline-list li:nth-child(odd) .timeline_content {
  grid-column: 2;
  margin-left: 40px;
}

ul.timeline-list li:nth-child(even) .timeline_content {
  grid-column: 1;
  margin-left: 40px;
}

.timeline_content > p {
  margin-top: 10px;
  line-height: 1.6;
}
</style>
